import { isEmpty } from '../util/utils';
import { getItemPricesObj } from './utilities';

export const getOrderAmount = (orderObj) => {
  let payableAmount = 0;
  let totalCost = 0;
  let voidedAmount = 0;

  orderObj.menuItems.map((menuItem, i) => {
    menuItem.orderIndex = i;

    let itemPrice = '';

    if (!isEmpty(menuItem.payablePrice)) {
      itemPrice = menuItem.payablePrice;
    } else {
      const { payablePrice } = getItemPricesObj(menuItem, {});
      itemPrice = payablePrice;
    }

    if (!menuItem.isVoided) {
      totalCost = totalCost + itemPrice;
    } else {
      voidedAmount = voidedAmount + itemPrice;
    }

    return menuItem;
  });

  payableAmount = Number(totalCost.toFixed(2));
  voidedAmount = Number(voidedAmount.toString(2));

  return { payableAmount, totalCost, voidedAmount };
};
